import {useId} from "react";
import EditableAutoCompleteBase from "./EditableAutoCompleteBase";

const timezones = [
    {id: "Pacific/Honolulu", display: "Hawaii"},
    {id: "America/Los_Angeles", display: "Los Angeles"},
    {id: "America/Phoenix", display: "Phoenix"},
    {id: "America/Denver", display: "Denver"},
    {id: "America/Chicago", display: "Chicago"},
    {id: "America/New_York", display: "New York"},
    {id: "America/Puerto_Rico", display: "Puerto Rico"},
];

const EditableCardEntryTimezone = ({isEditing, onEdit, baseValue}) => {
    const randomId = useId();

    return <EditableAutoCompleteBase
        label={"Timezone"}
        isEditing={isEditing}
        displayValue={baseValue}
        inputID={randomId}
        defaultValue={baseValue}
        items={timezones}
        idKey={"id"}
        nameKey={"display"}
        placeholder={"Timezone"}
        onSelect={onEdit}
        multiSelect={false}
    />;
}

export default EditableCardEntryTimezone;